import React from 'react';
import { useLocalization } from 'src/utils/useLocalization';

const BrandsList: React.FC<{ className: string }> = ({ className }) => {
    const { labelText } = useLocalization();
    const brands = [
        labelText.LABEL_TEXT_BRAND_AUDI_FINANCIAL_SERVICES,
        labelText.LABEL_TEXT_BRAND_DUCATI_FINANCIAL_SERVICES,
        labelText.LABEL_TEXT_BRAND_VOLKSWAGEN_FINANCIAL_SERVICES,
    ];

    return (
        <div className={className}>
            <ul>
                {brands.map((d, idx) => {
                    return <li key={`${idx}-${d}`}>{d} </li>;
                })}
            </ul>
        </div>
    );
};

export default BrandsList;
